import React from "react";
import styles from "./Loja.module.css"


const Loja = () =>{

    return(


        <div className={styles.container}>
            <p> Novidades em breve... </p>
        </div>

    )

}

export default Loja